import mrApi from './mrApi';

export default {
  getSystemSettingsById
};

export function getSystemSettingsById(params) {
  return mrApi.get('/api/systemSettings/getSystemSettingsById', { params });
}